import { apiurl } from '../../common/constants'
import { CategoryWithSubCategorySelect } from "../subcomponents/Selectors"
import { useAuthAxios } from '../authfetch'

const EditCategory = (props) => {
  const authAxios = useAuthAxios();
  
  const handleCategoryChange = (selectedValue) => {
    // Perform actions specific to this place
    const newCategoryname = document.querySelector(".newCategoryname")
    const result = props.categories.reduce((acc, item) => {
      if (item._id === selectedValue.slice(1,)) {
        acc.push(item.category_name);
      } else {
        const subcategory = item.subcategories.find(sub => sub._id === selectedValue.slice(1,));
        if (subcategory) {
          acc.push(subcategory.subcategory_name);
        }
      }
      return acc;
    }, []);
    newCategoryname.value = result[0]
    
  };

  const handleEditCategory = async () => {
    const form = document.querySelector('.editCategoryForm')
    let selectedCategory = document.querySelector("#editCategorySelect").value
    if (selectedCategory === "Select Category/SubCategory"){
      alert("Select Category/SubCategory first and edit to continue")
    }
    if (!form.checkValidity()){
      form.reportValidity()
      return
    }
    
    const editedCategory = document.querySelector(".newCategoryname").value
    
    try {
      const { data } = await authAxios.put(apiurl + "/categories", {
        _id: selectedCategory,
        category_name: editedCategory
      });
      console.log(data)
      if (data.status === "ok"){
        alert(data.message)
        props.setUpdates(prev => ({...prev, categoryUpdates: prev.categoryUpdates + 1}))
      } else {
        alert("something wrong.." + data.message)
      }
      form.reset()
    } catch (err) {
      console.log(err)
    }
  }

  const handleDeleteCategory = async () => {
    let selectedCategory = document.querySelector("#editCategorySelect").value

    const result = props.categories.reduce((acc, item) => {
      if (item._id === selectedCategory.slice(1,)) {
        acc.push(item.category_name);
      } else {
        const subcategory = item.subcategories.find(sub => sub._id === selectedCategory.slice(1,));
        if (subcategory) {
          acc.push(subcategory.subcategory_name);
        }
      }
      return acc;
    }, []);

    const catName = result[0]
    const answer = prompt(`Deleting  ${catName} will delete all product associated with ${catName}.Are you sure you want to delete category '${catName}'?(yes/no)`)
    if (answer !== "yes") return
    
    try {
      const response = await authAxios.delete(apiurl + "/categories", {
        data: { _id: selectedCategory }
      });
      if (response.status === 204){
        alert("deleted " + catName)
        props.setUpdates(prev => ({...prev, categoryUpdates: prev.categoryUpdates - 1}))
      }
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <>

        {/* <!-- Modal --> */}
      <div className="modal fade" id="editCategory" tabIndex="-1" aria-labelledby="editCategoryLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="editCategoryLabel">Edit Category</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className='container'>
                <form className='editCategoryForm'>
                <CategoryWithSubCategorySelect
                categories={props.categories}
                onChange={handleCategoryChange}
                selectId="editCategorySelect"
                firstOption="Select Category/SubCategory"
                 />
                <div className="input-group my-3">
                  <span className="input-group-text" id="basic-addon1">NewName</span>
                  <input type="text" className="form-control newCategoryname" placeholder="New Category Name" aria-label="newcatname" aria-describedby="basic-addon10" required/>
                </div>
                </form>
                
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-danger" onClick={handleDeleteCategory}><i className="fa-solid fa-trash-can"></i> Delete</button>
              <button type="button" className="btn btn-success" onClick={handleEditCategory}><i className="fa-solid fa-floppy-disk"></i> Edit changes</button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default EditCategory;
